import React from 'react';
import { Shield } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function ProofSection() {
  return <section className="py-24 bg-slate-900" data-id="element-194">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <ScrollFadeIn data-id="element-196">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-197">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-emerald-500/10 rounded-full blur-2xl" data-id="element-198" />

            <Shield className="w-12 h-12 text-emerald-400 mx-auto mb-6" data-id="element-199" />

            <h2 className="text-2xl md:text-3xl font-serif text-slate-50 mb-6 leading-relaxed" data-id="element-200">
              "Within the first 7 days, most users report a 'deflating' feeling
              in their midsection as systemic inflammation drops, followed by
              the first full night of uninterrupted sleep they've had in years."
            </h2>

            <div className="flex items-center justify-center space-x-2 text-emerald-400 font-medium" data-id="element-201">
              <span className="w-2 h-2 rounded-full bg-emerald-400" data-id="element-202" />
              <span data-id="element-203">Based on early user feedback</span>
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}